module.exports = __webpack_public_path__ + "static/media/14b-02-insolada.9fbf159f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/14b/14b-02-insolada.jpg
// module id = 150
// module chunks = 0